/* istanbul ignore file */

/* eslint-disable @typescript-eslint/no-this-alias, no-multi-assign, no-restricted-globals */
// borrowed from here: https://codepen.io/jordanwillis/pen/vxKBQY
function getBoxWidth(labelOpts, fontSize) {
  return labelOpts.usePointStyle ? fontSize * Math.SQRT2 : labelOpts.boxWidth;
}

export function initNewLegend(Chart) {
  Chart.NewLegend = Chart.Legend.extend({
    draw() {
      const me = this;
      const opts = me.options;
      const labelOpts = opts.labels;
      const globalDefault = Chart.defaults.global;
      const lineDefault = globalDefault.elements.line;
      const legendWidth = me.width;
      const {
        lineWidths
      } = me;

      if (opts.display) {
        const {
          ctx
        } = me;
        let cursor;
        const itemOrDefault = Chart.helpers.getValueOrDefault;
        const fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
        const fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
        const fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
        const fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
        const labelFont = Chart.helpers.fontString(fontSize, fontStyle, fontFamily); // Canvas setup

        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        ctx.lineWidth = 0.5;
        ctx.strokeStyle = fontColor; // for strikethrough effect

        ctx.fillStyle = fontColor; // render in correct colour

        ctx.font = labelFont;
        const boxWidth = getBoxWidth(labelOpts, fontSize);
        const hitboxes = me.legendHitBoxes; // current position

        const drawLegendBox = function (x, y, legendItem) {
          if (isNaN(boxWidth) || boxWidth <= 0) {
            return;
          } // Set the ctx for the box


          ctx.save();
          ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
          ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
          ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
          ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
          ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
          ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
          const isLineWidthZero = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0;

          if (ctx.setLineDash) {
            // IE 9 and 10 do not support line dash
            ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
          }

          if (opts.labels && opts.labels.usePointStyle) {
            // Recalculate x and y for drawPoint() because its expecting
            // x and y to be center of figure (instead of top left)
            const radius = fontSize * Math.SQRT2 / 2;
            const offSet = radius / Math.SQRT2;
            const centerX = x + offSet;
            const centerY = y + offSet; // Draw pointStyle as legend symbol

            Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
          } else {
            // Draw box as legend symbol
            if (!isLineWidthZero) {
              ctx.strokeRect(x, y, boxWidth, fontSize);
            }

            ctx.fillRect(x, y, boxWidth, fontSize);
          }

          ctx.restore();
        }; // this is where the strike through was added


        const fillText = function (x, y, legendItem
        /* , textWidth */
        ) {
          if (legendItem.hidden) {
            // lighten the hidden text
            ctx.fillStyle = Chart.helpers.color(fontColor).alpha(0.66).rgbaString();
          }

          ctx.fillText(legendItem.text, boxWidth + fontSize / 2 + x, y); // restore the original fillStyle so we dont impact the rest of the labels

          ctx.fillStyle = fontColor;
        }; // Horizontal


        const isHorizontal = me.isHorizontal();

        if (isHorizontal) {
          cursor = {
            x: me.left + (legendWidth - lineWidths[0]) / 2,
            y: me.top + labelOpts.padding,
            line: 0
          };
        } else {
          cursor = {
            x: me.left + labelOpts.padding,
            y: me.top + labelOpts.padding,
            line: 0
          };
        }

        const itemHeight = fontSize + labelOpts.padding;
        Chart.helpers.each(me.legendItems, function (legendItem, i) {
          const textWidth = ctx.measureText(legendItem.text).width;
          const width = boxWidth + fontSize / 2 + textWidth;
          let {
            x
          } = cursor;
          let {
            y
          } = cursor;

          if (isHorizontal) {
            if (x + width >= legendWidth) {
              y = cursor.y += itemHeight;
              cursor.line++;
              x = cursor.x = me.left + (legendWidth - lineWidths[cursor.line]) / 2;
            }
          } else if (y + itemHeight > me.bottom) {
            x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
            y = cursor.y = me.top + labelOpts.padding;
            cursor.line++;
          }

          drawLegendBox(x, y, legendItem);
          hitboxes[i].left = x;
          hitboxes[i].top = y; // Fill the actual label

          fillText(x, y, legendItem, textWidth);

          if (isHorizontal) {
            cursor.x += width + labelOpts.padding;
          } else {
            cursor.y += itemHeight;
          }
        });
      }
    }

  });

  function createNewLegendAndAttach(chartInstance, legendOpts) {
    const legend = new Chart.NewLegend({
      ctx: chartInstance.chart.ctx,
      options: legendOpts,
      chart: chartInstance
    });

    if (chartInstance.legend) {
      Chart.layoutService.removeBox(chartInstance, chartInstance.legend);
      delete chartInstance.newLegend;
    }

    chartInstance.newLegend = legend;
    Chart.layoutService.addBox(chartInstance, legend);
  } // Register the legend plugin


  Chart.plugins.register({
    beforeInit(chartInstance) {
      const legendOpts = chartInstance.options.legend;

      if (legendOpts) {
        createNewLegendAndAttach(chartInstance, legendOpts);
      }
    },

    beforeUpdate(chartInstance) {
      let legendOpts = chartInstance.options.legend;

      if (legendOpts) {
        legendOpts = Chart.helpers.configMerge(Chart.defaults.global.legend, legendOpts);

        if (chartInstance.newLegend) {
          chartInstance.newLegend.options = legendOpts;
        } else {
          createNewLegendAndAttach(chartInstance, legendOpts);
        }
      } else {
        Chart.layoutService.removeBox(chartInstance, chartInstance.newLegend);
        delete chartInstance.newLegend;
      }
    },

    afterEvent(chartInstance, e) {
      const legend = chartInstance.newLegend;

      if (legend) {
        legend.handleEvent(e);
      }
    }

  });
}